import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/favourite-administration/list/types-store';

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, deletingFavourite, deleteFavourite, translation
}) => listItems?.length > 0
    ? <div>
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.code.value}
          item={listItem}
          deleting={deletingFavourite?.includes(listItem.code.value)}
          deleteFavourite={deleteFavourite}
          translation={translation}
        />;
      })}
    </div>
    : null;
